// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pipeline-menu .p-tabmenuitem {
  margin-right: 25px !important;
}

.pipeline-menu .p-menuitem-icon {
  font-size: 25px !important;
  font-weight: 100 !important;
}

.pipeline-menu .p-menuitem-text {
  font-size: 18px !important;
  font-weight: 400 !important;
}

.p-tabmenu .p-tabmenu-nav .p-tabmenuitem.p-highlight .p-menuitem-link {
  background: #ffffff;
  border-color: #000000;
  color: #000000;
}

@media screen and (max-width: 1300px) {
  .pipeline-menu .p-tabmenuitem {
    margin-right: 0px !important;
  }

  .pipeline-menu .p-menuitem-icon {
    font-size: 20px !important;
  }

  .pipeline-menu .p-menuitem-text {
    font-size: 16px !important;
    font-weight: 400 !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/layout/MenuBar/MenuBar.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;AACF","sourcesContent":[".pipeline-menu .p-tabmenuitem {\n  margin-right: 25px !important;\n}\n\n.pipeline-menu .p-menuitem-icon {\n  font-size: 25px !important;\n  font-weight: 100 !important;\n}\n\n.pipeline-menu .p-menuitem-text {\n  font-size: 18px !important;\n  font-weight: 400 !important;\n}\n\n.p-tabmenu .p-tabmenu-nav .p-tabmenuitem.p-highlight .p-menuitem-link {\n  background: #ffffff;\n  border-color: #000000;\n  color: #000000;\n}\n\n@media screen and (max-width: 1300px) {\n  .pipeline-menu .p-tabmenuitem {\n    margin-right: 0px !important;\n  }\n\n  .pipeline-menu .p-menuitem-icon {\n    font-size: 20px !important;\n  }\n\n  .pipeline-menu .p-menuitem-text {\n    font-size: 16px !important;\n    font-weight: 400 !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
